module.exports = __webpack_public_path__ + "static/media/designation.0ce3b43b.png";